import {
  onDisconnect,
  ref,
  remove,
  serverTimestamp,
  set,
} from "firebase/database";
import { collection, onSnapshot } from "firebase/firestore";
import type { Unsubscribe } from "firebase/firestore";

import { db, rtdb } from "../firebase/client";
import { decodePresence } from "./decoders";
import type { PresenceModel } from "../shared/types/contracts";

function identified(id: string, value: unknown): Record<string, unknown> {
  const data =
    typeof value === "object" && value !== null && !Array.isArray(value)
      ? (value as Record<string, unknown>)
      : {};
  return { id, ...data };
}

export function startPresence(
  teamId: string,
  uid: string,
  clientId: string,
): () => void {
  const connection = ref(rtdb, `status/${teamId}/${uid}/${clientId}`);
  const disconnect = onDisconnect(connection);
  disconnect.remove().catch(() => {});
  set(connection, { state: "online", lastChanged: serverTimestamp() }).catch(
    () => {},
  );
  return () => {
    disconnect.cancel().catch(() => {});
    remove(connection).catch(() => {});
  };
}

export function observePresence(
  teamId: string,
  onDocs: (documents: PresenceModel[]) => void,
  onError: (error: unknown) => void,
): Unsubscribe {
  return onSnapshot(
    collection(db, "teams", teamId, "presence"),
    (snapshot) => {
      try {
        onDocs(
          snapshot.docs.map((entry) =>
            decodePresence(identified(entry.id, entry.data())),
          ),
        );
      } catch (error) {
        onError(error);
      }
    },
    onError,
  );
}
